import Box from '@mui/material/Box';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import useAppSelector from '@webclient/hooks/useAppSelector';
import useWorkspace from '@webclient/hooks/useWorkspace';

import { useTranslate } from '@tolgee/react';
import StyledListItem from '@webclient/layouts/main/sections/toolbar/components/expanded-list-item/styles';
import CONFIG_TOOLBAR from '@webclient/layouts/main/sections/toolbar/config';
import { StyledNavLink } from '@webclient/layouts/main/sections/toolbar/styles';

export default function ExpandedListItem() {
  const { t } = useTranslate();
  const me = useAppSelector((state) => state.auth.me);
  const { setupMode } = useWorkspace();

  return (
    <Box sx={{ p: 3 }}>
      {CONFIG_TOOLBAR.TOOLBAR_ITEMS.filter(
        ({ isAlpha }) => me?.alpha || !isAlpha,
      )
        .filter(({ setupMode: singleSetupMode }) =>
          singleSetupMode.includes(setupMode),
        )
        .map(({ defaultLabel, icon, mappedLabel, url }, i) => (
          <StyledListItem
            to={url}
            key={i}
            component={StyledNavLink}
            disablePadding
            disableGutters
          >
            <ListItemButton>
              <ListItemIcon>{icon}</ListItemIcon>
              <ListItemText
                primary={t(mappedLabel, defaultLabel)}
                primaryTypographyProps={{
                  variant: 'textMd',
                }}
              />
            </ListItemButton>
          </StyledListItem>
        ))}
    </Box>
  );
}
